<template>
  <div class="diff">
    <el-form :model="form" ref="form" :rules="rules">
      <div class="formWrapper">
        <AutoForm
          :labelWidth="'240px'"
          :autoForm="form"
          ref="autoForm1"
          :disabled="!editable"
        ></AutoForm>
      </div>
      <!-- <el-form-item v-if="editable">
        <el-button type="primary" @click="submit">保存</el-button>
      </el-form-item> -->
    </el-form>
    <div v-if="editable" class="subBox">
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
  </div>
</template>

<script>
import Keyboard from "@/components/keyboard/index.vue";
import AutoForm from "@/components/autoForm/index.vue";
import { ElNotification } from "element-plus";

export default {
  name: "Page",
  components: { AutoForm, Keyboard },
  data() {
    return {
      rules: {
        days: [
          {
            required: true,
            message: "必填",
          },
        ],
      },
      form: [],
      editable: true,
    };
  },
  methods: {
    async submit() {
      try {
        // console.log(v.$refs.form.validate);
        let valRes = await this.$refs.autoForm1.$refs.form.validate();
        console.log(valRes);
      } catch (err) {
        console.log("err autoForm1");
        console.log(err);
        return;
      }
      // return;
      try {
        let res = await this.$myRequest({
          url: "/post-system-variables",
          method: "post",
          data: this.form,
        });
        ElNotification({
          title: "提示",
          message: "操作成功",
          type: "success",
        });
        this.init();
      } catch (err) {
        console.log("save err");
        console.log(err);
      }
    },
    async init() {
      // debugger;
      try {
        let res;
        res = await this.$myRequest({
          url: "/list-system-variables",
          method: "get",
          data: {},
        });
        console.log("res param init");
        console.log(res);
        this.form = res.data.data;
      } catch (err) {
        console.log("err param init");
        console.log(err);
      }
    },
  },
  mounted() {
    console.log("param form mounted");
    this.init();
    if (this.$route.name == "userSetParam") {
      this.editable = false;
    }

    this.$store.commit("checkTick");
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
